import { z } from 'zod'

// Citation into an earlier form submission on the same request (the `other_request_forms` slice), mirroring
// the `question` citation shape: the content is upfront context, so resolution validates the reference
// rather than verifying an anchor against drilled text.
export const OtherRequestFormCitationAgentInputSchema = z.object({
  type: z.literal('other_request_form'),
  questionName: z.string().describe('The question name within the earlier form submission on this request'),
  formTitle: z.string().describe('The form title containing the question, as shown in its heading'),
  textAnchor: z
    .string()
    .describe(
      'Short phrase (3–8 words) from the paragraph text that references this source. Must appear verbatim in the paragraph text. Use null when there is no anchor phrase.'
    )
    .nullable(),
})

export const OtherRequestFormCitationResolvedSchema = z.object({
  sourceType: z.literal('other_request_form'),
  sourceLabel: z.string(),
  quote: z.string(),
  questionName: z.string(),
  // Human-readable question title (resolver-supplied from the form config), for display; `questionName`
  // stays the stable identifier the agent cites by.
  questionTitle: z.string(),
  requestFormId: z.string(),
  formTitle: z.string(),
  textAnchor: z.string().nullable(),
})
export type OtherRequestFormCitationResolved = z.infer<typeof OtherRequestFormCitationResolvedSchema>
